import React from 'react';
import { Grid } from '@material-ui/core';
import { Article } from '../../../../../types/items';
import UploadFailMedia from './UploadFailMedia';
import ProcessingMedia from './ProcessingMedia';
import { MediaStyles } from './styles';
import { getDocumentThumbnailUrl, getVideoThumbnailUrl } from '../utils';
import { FileIcon, VolumeUpIcon } from '../../../../../components/icon/solid';

type Props = {
  media: Article;
  openMediaPreview: () => void;
};

const MediaItemImage = ({ media, openMediaPreview }: Props) => {
  const classes = MediaStyles();
  const isVideo = media.video_id !== -1;
  const isAudio = (media.ref.document?.media_type_id === 3);
  const isOther = (media.ref.document?.media_type_id === 0);
  const { document } = media.ref;
  const src = !isVideo
    ? getDocumentThumbnailUrl(media.ref.document?.thumbnails || [])
    : getVideoThumbnailUrl(media.ref.video?.ref?.thumbnails || []);
  let content = <img src={src} alt="" className={classes.media} />;
  let isMediaFailed;
  let isProcessingMedia;
  const isUploading = Boolean(media.ref?.video?.ref?.is_uploading) || Boolean(document?.ref.is_uploading) || false;

  if (isAudio) {
    content = <Grid item><VolumeUpIcon className={classes.titleIcon} /></Grid>;
  }

  if (isOther) {
    content = <Grid item><FileIcon className={classes.titleIcon} /></Grid>;
  }

  if (isVideo) {
    isMediaFailed = media.ref.video?.ref.upload_status.id === 2;
    isProcessingMedia = Boolean(media.ref.video?.ref?.is_processing);
  } else {
    isMediaFailed = Boolean(document?.ref.is_failed);
    isProcessingMedia = Boolean(document?.ref.is_processing);
  }

  if (isProcessingMedia || isUploading) {
    content = <ProcessingMedia upload={isUploading} />;
  }

  if (isMediaFailed) {
    content = <UploadFailMedia />;
  }

  return (
    <Grid
      onClick={!isMediaFailed ? openMediaPreview : () => {}}
      item
      container
      xs={12}
      alignItems="center"
      justify="center"
      className={`${classes.mediaContainer} ${isMediaFailed ? classes.mediaContainerBottom : ''}`}
    >
      {content}
    </Grid>
  );
};

export default MediaItemImage;
